module.exports = __webpack_public_path__ + "static/mahadi-mtg_clb-5c1e7c996491f93d8afb04de556f8cad.jpg";